import React from "react"
import { useTheme } from "@material-ui/core"
import { DomainDisabledOutlined } from "@material-ui/icons";

import StatusChip from "./StatusChip";

export default ({ record }) => {
  const theme = useTheme();

  if (record?.isSanctioned !== false) return null;
  return <StatusChip
    themeColor={theme.palette.pink}
    tooltipText="resources.teams.tooltips.unsanctioned"
    label="resources.teams.chips.unsanctioned"
    icon={DomainDisabledOutlined}
  />
}
